<div class="section" *ngIf="hasValue">
	<div class="title">
		{{ header }}
	</div>
	<div class="content">
		<ng-container *ngFor="let value of values">
			<show-more-less
				[content]="value | nl2br"
				[maxHeight]="maxHeight"
			></show-more-less>
		</ng-container>
	</div>
</div>
